import React, { Component } from "react";
import {
    PageHeader,
    Spin,
    Card,
    Row,
    Col,
    Statistic,
    Tag,
    Tooltip,
    message,
    Modal,
    Divider,
    Popconfirm,
    Progress,
    Alert,
    Tabs,
    notification,
} from "antd";
import {
    CheckOutlined,
    CloseOutlined,
    EyeOutlined,
    ExclamationCircleOutlined,
    CheckCircleOutlined,
    FilePdfOutlined,
} from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ButtonItem, TableItem } from "../../../../Components/Items";
import { ResponsivePie } from "@nivo/pie";
import { ResponsiveBar } from "@nivo/bar";
import pdfMake from "pdfmake/build/pdfmake";
import conteoDetallePdf from "../../../../Pdf/conteoDetallePdf";

moment.locale("es");

const { TabPane } = Tabs;

const MODO_LABELS = { 1: "Ciego", 2: "Semi-ciego", 3: "Abierto" };
const ESTRATEGIA_LABELS = {
    1: "Más rotación",
    2: "Menos rotación",
    3: "Aleatorio (existentes)",
    4: "Aleatorio (todos)",
    5: "Todos",
    6: "Todos con existencia",
};

const TH_BASE = { background: "#e6f7fa", color: "#006d75", fontWeight: 600, padding: "10px 12px", whiteSpace: "nowrap" };
const TH_LEFT = TH_BASE;
const TH_NUM = (extra = {}) => ({ ...TH_BASE, textAlign: "right", ...extra });
const TH_CENTER = (extra = {}) => ({ ...TH_BASE, textAlign: "center", ...extra });
const TD_BASE = { padding: "8px 12px", verticalAlign: "middle" };
const TD_LEFT = TD_BASE;
const TD_RIGHT = (extra = {}) => ({ ...TD_BASE, textAlign: "right", ...extra });
const TD_CENTER = (extra = {}) => ({ ...TD_BASE, textAlign: "center", ...extra });

class DetalleConteo extends Component {
    state = {
        loading: false,
        conteo: null,
        ordenes: [],
        modalVisible: false,
        loadingModal: false,
        ordenSeleccionada: null,
        insumosModal: [],
        diferencias: [],
        resumenDif: null,
        loadingDif: false,
        mostrandoDif: false,
        resumenPorOrden: [],
        loadingResumen: false,
        resumenReconteos: null,
        loadingReconteos: false,
        loadingAjuste: false,
        id: this.props.match.params.id,
    };

    componentDidMount() {
        this.consultarDetalle();
    }

    async consultarDetalle() {
        this.setState({ loading: true });
        try {
            const res = await axios.post(
                "conteos/selectDetalleConteo",
                { empresaId: this.props.empresaId, conteoId: this.state.id },
                { headers: this.props.headersToken }
            );
            if (res.data.success === 2) {
                this.setState({ conteo: res.data.conteo, ordenes: res.data.ordenes || [] });
            } else {
                message.error("No se encontró el conteo");
            }
        } catch {
            message.error("Error de conexión");
        }
        this.setState({ loading: false });
    }

    async abrirRevision(record) {
        this.setState({ modalVisible: true, ordenSeleccionada: record, insumosModal: [], loadingModal: true });
        try {
            const res = await axios.post(
                "ordenesDeConteo/selectOrdenDeConteo",
                { empresaId: this.props.empresaId, ordenDeConteoId: record._id },
                { headers: this.props.headersToken }
            );
            if (res.data.success === 2) {
                // Reemplazar ordenSeleccionada con el objeto completo del servidor
                this.setState({
                    ordenSeleccionada: res.data.orden,
                    insumosModal: res.data.orden?.insumos || [],
                });
            } else {
                message.error("No se pudieron cargar los insumos");
            }
        } catch {
            message.error("Error de conexión");
        }
        this.setState({ loadingModal: false });
    }

    cerrarModal() {
        this.setState({ modalVisible: false, ordenSeleccionada: null, insumosModal: [] });
    }

    async rechazarOrden() {
        const { ordenSeleccionada } = this.state;
        this.setState({ loadingModal: true });
        try {
            const res = await axios.post(
                "ordenesDeConteo/rechazarOrdenDeConteo",
                { empresaId: this.props.empresaId, ordenDeConteoId: ordenSeleccionada._id },
                { headers: this.props.headersToken }
            );
            if (res.data.success === 2) {
                message.success("Orden rechazada — se solicitó reconteo");
                this.cerrarModal();
                this.consultarDetalle();
            } else {
                message.error(res.data.err || "No se pudo rechazar la orden");
            }
        } catch {
            message.error("Error de conexión");
        }
        this.setState({ loadingModal: false });
    }

    async aprobarOrden() {
        const { ordenSeleccionada } = this.state;
        this.setState({ loadingModal: true });
        try {
            const res = await axios.post(
                "ordenesDeConteo/aprobarOrdenDeConteo",
                { empresaId: this.props.empresaId, ordenDeConteoId: ordenSeleccionada._id },
                { headers: this.props.headersToken }
            );
            if (res.data.success === 2) {
                message.success("Orden aprobada correctamente");
                this.cerrarModal();
                this.consultarDetalle();
            } else {
                message.error("No se pudo aprobar la orden");
            }
        } catch {
            message.error("Error de conexión");
        }
        this.setState({ loadingModal: false });
    }

    async rechazarOrdenDesdeTabla(ordenDeConteoId) {
        this.setState({ loading: true });
        try {
            const res = await axios.post(
                "ordenesDeConteo/rechazarOrdenDeConteo",
                { empresaId: this.props.empresaId, ordenDeConteoId },
                { headers: this.props.headersToken }
            );
            if (res.data.success === 2) {
                message.success("Orden rechazada — se solicitó reconteo");
                this.consultarDetalle();
            } else {
                message.error(res.data.err || "No se pudo rechazar la orden");
            }
        } catch {
            message.error("Error de conexión");
        }
        this.setState({ loading: false });
    }

    async aprobarOrdenDesdeTabla(ordenDeConteoId) {
        this.setState({ loading: true });
        try {
            const res = await axios.post(
                "ordenesDeConteo/aprobarOrdenDeConteo",
                { empresaId: this.props.empresaId, ordenDeConteoId },
                { headers: this.props.headersToken }
            );
            if (res.data.success === 2) {
                message.success("Orden aprobada correctamente");
                this.consultarDetalle();
            } else {
                message.error("No se pudo aprobar la orden");
            }
        } catch {
            message.error("Error de conexión");
        }
        this.setState({ loading: false });
    }

    async consultarDiferencias() {
        this.setState({ loadingDif: true, mostrandoDif: true });
        try {
            const res = await axios.post(
                "conteos/selectDiferenciasConteo",
                { empresaId: this.props.empresaId, conteoId: this.state.id },
                { headers: this.props.headersToken }
            );
            if (res.data.success === 2) {
                const diferencias = res.data.insumos || [];
                const insumosConDif = res.data.insumosConDiferencia
                    ?? diferencias.filter((d) => d.diferenciaFinal !== 0).length;
                const totalInsumos = res.data.totalInsumos ?? diferencias.length;
                this.setState({
                    diferencias,
                    resumenDif: {
                        totalInsumos,
                        insumosConDiferencia: insumosConDif,
                        insumosSinDiferencia: res.data.insumosSinDiferencia ?? (totalInsumos - insumosConDif),
                    },
                });
            } else {
                message.error("No se pudieron cargar las diferencias");
            }
        } catch {
            message.error("Error de conexión");
        }
        this.setState({ loadingDif: false });
    }

    async consultarResumenPorOrden() {
        this.setState({ loadingResumen: true });
        try {
            const res = await axios.post(
                "conteos/selectResumenPorOrden",
                { empresaId: this.props.empresaId, conteoId: this.state.id },
                { headers: this.props.headersToken }
            );
            if (res.data.success === 2) {
                this.setState({ resumenPorOrden: res.data.resumen || [] });
            } else {
                message.error("No se pudo cargar el resumen por orden");
            }
        } catch {
            message.error("Error de conexión");
        }
        this.setState({ loadingResumen: false });
    }

    async consultarReconteos() {
        this.setState({ loadingReconteos: true });
        try {
            const res = await axios.post(
                "conteos/selectResumenReconteos",
                { empresaId: this.props.empresaId, conteoId: this.state.id },
                { headers: this.props.headersToken }
            );
            if (res.data.success === 2) {
                this.setState({ resumenReconteos: res.data });
            } else {
                message.error("No se pudo cargar el resumen de reconteos");
            }
        } catch {
            message.error("Error de conexión");
        }
        this.setState({ loadingReconteos: false });
    }

    async aplicarAjustes() {
        this.setState({ loadingAjuste: true });
        try {
            const res = await axios.post(
                "conteos/aplicarAjustesConteo",
                { empresaId: this.props.empresaId, conteoId: this.state.id },
                { headers: this.props.headersToken }
            );
            if (res.data.success === 2) {
                message.success("Ajustes de inventario aplicados correctamente");
                if (res.data.ordenesAgregarInventario === 1){
                    notification.info({
                        message: "Se creo una orden de agregar inventario",
                        description: "Confirme la orden de agregar inventario creada para revisar los insumos que se ajustaron y sus lotes asignados.",
                    })
                }
                if (res.data.ordenesProductosAlCosto === 1){
                    notification.info({
                        message: "Se creo una orden de productos al costo",
                        description: "Confirme la orden de productos al costo creada para revisar los insumos que se ajustaron y sus lotes asignados.",
                    })
                }
                this.consultarDetalle();
            } else {
                message.error("No se pudieron aplicar los ajustes");
            }
        } catch {
            message.error("Error de conexión");
        }
        this.setState({ loadingAjuste: false });
    }

    async descargarPdf() {
        const { conteo, ordenes } = this.state;
        if (!conteo) { return; }

        let { diferencias, resumenDif, resumenReconteos } = this.state;

        if (!this.state.mostrandoDif) {
            try {
                const res = await axios.post(
                    "conteos/selectDiferenciasConteo",
                    { empresaId: this.props.empresaId, conteoId: this.state.id },
                    { headers: this.props.headersToken }
                );
                if (res.data.success === 2) {
                    diferencias = res.data.insumos || [];
                    const insumosConDif = res.data.insumosConDiferencia
                        ?? diferencias.filter((d) => d.diferenciaFinal !== 0).length;
                    const totalInsumos = res.data.totalInsumos ?? diferencias.length;
                    resumenDif = {
                        totalInsumos,
                        insumosConDiferencia: insumosConDif,
                        insumosSinDiferencia: res.data.insumosSinDiferencia ?? (totalInsumos - insumosConDif),
                    };
                }
            } catch { /* silently omit diffs from PDF */ }
        }

        if (!resumenReconteos) {
            try {
                const res = await axios.post(
                    "conteos/selectResumenReconteos",
                    { empresaId: this.props.empresaId, conteoId: this.state.id },
                    { headers: this.props.headersToken }
                );
                if (res.data.success === 2) {
                    resumenReconteos = res.data;
                }
            } catch { /* silently omit reconteos from PDF */ }
        }

        const pdf = conteoDetallePdf({ conteo, ordenes, diferencias, resumenDif, resumenReconteos });
        pdfMake.createPdf(pdf).download(`Conteo-${conteo.nombre || conteo._id}.pdf`);
    }

    atras() {
        this.props.history.goBack();
    }

    renderEstadoOrden(estado) {
        switch (estado) {
            case 0: return <Tag color="red">Cancelada</Tag>;
            case 1: return <Tag color="default">Pendiente</Tag>;
            case 2: return <Tag color="blue">Contando</Tag>;
            case 3: return <Tag color="green">Finalizada</Tag>;
            default: return <Tag>—</Tag>;
        }
    }

    renderEstadoConteo(estado) {
        switch (estado) {
            case 0: return <Tag color="red">Cancelado</Tag>;
            case 1: return <Tag color="blue">Activo</Tag>;
            case 2: return <Tag color="orange">En revisión</Tag>;
            case 3: return <Tag color="green">Finalizado</Tag>;
            default: return <Tag>—</Tag>;
        }
    }

    render() {
        const {
            loading, conteo, ordenes, modalVisible, loadingModal, ordenSeleccionada, insumosModal,
            diferencias, resumenDif, mostrandoDif, loadingDif, loadingAjuste,
        } = this.state;
        const { usuarioId } = this.props;

        const totalOrdenes = ordenes.length;
        const contadas = ordenes.filter((o) => o.estado === 3).length;
        const aprobadas = ordenes.filter((o) => o.aprobada).length;
        const todasAprobadas = totalOrdenes > 0 && aprobadas === totalOrdenes;
        const progreso = totalOrdenes > 0 ? Math.round((aprobadas / totalOrdenes) * 100) : 0;

        const supervisorIdDeOrden = ordenSeleccionada?.supervisorId
            ?? ordenSeleccionada?.supervisor?._id
            ?? null;
        const esSupervisorDeOrden = supervisorIdDeOrden != null
            && String(supervisorIdDeOrden) === String(usuarioId) && ordenSeleccionada?.estado === 3 && !ordenSeleccionada?.aprobada;

        // Igual que maxIntento en VerOrdenDeConteo
        const maxConteos = insumosModal.reduce(
            (max, i) => Math.max(max, i.conteos?.length || 0), 0
        );

        // La columna de codigo de barras aparece solo si algun insumo del conjunto lo tiene
        // capturado, para no ensanchar la tabla con una columna de puros guiones. Cada tabla
        // decide por su cuenta porque son conjuntos distintos (una orden vs todo el conteo).
        const mostrarCodigoBarrasModal = insumosModal.some((i) => !!i.codigoBarras);
        const mostrarCodigoBarrasDif = diferencias.some((d) => !!d.codigoBarras);

        const columnasOrdenes = [
            {
                title: "N°",
                dataIndex: "serieNumero",
                key: "serieNumero",
                width: "8%",
            },
            {
                title: "Responsable",
                dataIndex: "responsableNombre",
                key: "responsableNombre",
                width: "18%",
            },
            {
                title: "Supervisor",
                dataIndex: "supervisorNombre",
                key: "supervisorNombre",
                width: "14%",
            },
            {
                title: "Insumos",
                dataIndex: "totalInsumos",
                key: "totalInsumos",
                width: "9%",
                render: (v, r) => `${r.insumosContados ?? 0} / ${v ?? 0}`,
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                width: "10%",
                render: (v) => this.renderEstadoOrden(v),
            },
            {
                title: "Fecha inicio",
                dataIndex: "fechaInicio",
                key: "fechaInicio",
                width: "11%",
                render: (v) => (v ? moment(v).format("DD/MM/YY HH:mm") : "—"),
            },
            {
                title: "Fecha término",
                dataIndex: "fechaTermino",
                key: "fechaTermino",
                width: "11%",
                render: (v) => (v ? moment(v).format("DD/MM/YY HH:mm") : "—"),
            },
            {
                title: "Acción",
                key: "accion",
                width: "18%",
                render: (_, record) => {
                    const puedeAprobar =
                        record.estado === 3 &&
                        String(record.supervisorId) === String(usuarioId) && !record.aprobada;
                    return (
                        <div className="acciones-container">
                            <Tooltip title="Revisar orden">
                                <ButtonItem
                                    type="primary"
                                    size="small"
                                    icon={<EyeOutlined />}
                                    onClick={() => this.abrirRevision(record)}
                                    disabled={record.estado < 2}
                                >
                                    Revisar
                                </ButtonItem>
                            </Tooltip>
                            {puedeAprobar && (
                                <Popconfirm
                                    title="¿Rechazar esta orden y solicitar reconteo?"
                                    onConfirm={() => this.rechazarOrdenDesdeTabla(record._id)}
                                    okText="Rechazar"
                                    okButtonProps={{ danger: true }}
                                    cancelText="Cancelar"
                                    icon={<ExclamationCircleOutlined style={{ color: "#f5222d" }} />}
                                >
                                    <Tooltip title="Rechazar">
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            danger
                                            icon={<CloseOutlined />}
                                            style={{ marginLeft: 4 }}
                                        />
                                    </Tooltip>
                                </Popconfirm>
                            )}
                            {puedeAprobar && (
                                <Popconfirm
                                    title="¿Aprobar esta orden de conteo?"
                                    onConfirm={() => this.aprobarOrdenDesdeTabla(record._id)}
                                    okText="Aprobar"
                                    cancelText="Cancelar"
                                >
                                    <Tooltip title="Aprobar">
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            verde
                                            icon={<CheckCircleOutlined />}
                                            style={{ marginLeft: 4 }}
                                        />
                                    </Tooltip>
                                </Popconfirm>
                            )}
                        </div>
                    );
                },
            },
        ];

        const columnasDif = [
            {
                title: "Insumo",
                dataIndex: "nombre",
                key: "nombre",
            },
            ...(mostrarCodigoBarrasDif ? [{
                title: "Cód. barras",
                dataIndex: "codigoBarras",
                key: "codigoBarras",
                width: "14%",
                render: (v) => <span style={{ fontFamily: "monospace", color: "#595959" }}>{v || "—"}</span>,
            }] : []),
            {
                title: "Snapshot sistema",
                dataIndex: "snapshotFinal",
                key: "snapshotFinal",
                width: "14%",
                align: "right",
                render: (v) => v ?? "—",
            },
            {
                title: "Cantidad final",
                dataIndex: "cantidadFinal",
                key: "cantidadFinal",
                width: "13%",
                align: "right",
                render: (v) => v ?? "—",
            },
            {
                title: "Diferencia",
                dataIndex: "diferenciaFinal",
                key: "diferenciaFinal",
                width: "12%",
                align: "right",
                render: (v) => {
                    if (v == null) return "—";
                    const color = v === 0 ? "#52c41a" : v > 0 ? "#1677ff" : "#f5222d";
                    return <span style={{ color, fontWeight: 600 }}>{v > 0 ? `+${v}` : v}</span>;
                },
            },
            {
                title: "% Diferencia",
                dataIndex: "porcentajeDiferencia",
                key: "porcentajeDiferencia",
                width: "12%",
                align: "right",
                render: (v, r) => {
                    const pct = v ?? (r.snapshotFinal && r.diferenciaFinal != null
                        ? ((r.diferenciaFinal / r.snapshotFinal) * 100)
                        : null);
                    if (pct == null) return "—";
                    const color = pct === 0 ? "#52c41a" : "#f5222d";
                    return (
                        <span style={{ color, fontWeight: 600 }}>
                            {`${pct > 0 ? "+" : ""}${pct.toFixed(1)}%`}
                        </span>
                    );
                },
            },
            {
                title: "Ajuste",
                dataIndex: "ajusteAplicado",
                key: "ajusteAplicado",
                width: "10%",
                align: "center",
                render: (v) => v ? <Tag color="green">Aplicado</Tag> : <Tag color="default">Pendiente</Tag>,
            },
        ];

        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title={conteo ? `Conteo: ${conteo.nombre}` : "Detalle de Conteo"}
                    tags={conteo ? this.renderEstadoConteo(conteo.estado) : null}
                    extra={
                        conteo && (
                            <ButtonItem
                                icon={<FilePdfOutlined />}
                                onClick={this.descargarPdf.bind(this)}
                            >
                                Descargar PDF
                            </ButtonItem>
                        )
                    }
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                />
                <div style={{ backgroundColor: "white", padding: "0 20px 20px" }}>
                    <Tabs
                        defaultActiveKey="general"
                        onChange={(key) => {
                            if (key === "estadisticas" && !this.state.mostrandoDif) {
                                this.consultarDiferencias();
                            }
                            if (key === "porOrden" && this.state.resumenPorOrden.length === 0) {
                                this.consultarResumenPorOrden();
                            }
                            if (key === "reconteos" && !this.state.resumenReconteos) {
                                this.consultarReconteos();
                            }
                        }}
                    >
                        <TabPane tab="General" key="general">
                            <Spin spinning={loading}>
                                {/* Info del conteo */}
                                {conteo && (
                                    <Card
                                        style={{ marginBottom: 16, borderRadius: 8, border: "1px solid #d9f2f5", background: "#f0f9fa" }}
                                        bodyStyle={{ padding: "12px 18px" }}
                                    >
                                        <Row gutter={[32, 8]}>
                                            <Col>
                                                <div style={{ fontSize: 11, color: "#8c8c8c" }}>Modo de conteo</div>
                                                <div style={{ fontSize: 13, fontWeight: 500 }}>{MODO_LABELS[conteo.modoConteo] || "—"}</div>
                                            </Col>
                                            <Col>
                                                <div style={{ fontSize: 11, color: "#8c8c8c" }}>Estrategia</div>
                                                <div style={{ fontSize: 13, fontWeight: 500 }}>{ESTRATEGIA_LABELS[conteo.estrategiaSeleccionInsumos] || "—"}</div>
                                            </Col>
                                            <Col>
                                                <div style={{ fontSize: 11, color: "#8c8c8c" }}>Supervisor</div>
                                                <div style={{ fontSize: 13, fontWeight: 500 }}>{conteo.supervisorNombre || "—"}</div>
                                            </Col>
                                            <Col>
                                                <div style={{ fontSize: 11, color: "#8c8c8c" }}>Proyecto</div>
                                                <div style={{ fontSize: 13, fontWeight: 500 }}>{conteo.proyectoNombre || "—"}</div>
                                            </Col>
                                            {conteo.fechaInicio && (
                                                <Col>
                                                    <div style={{ fontSize: 11, color: "#8c8c8c" }}>Inicio</div>
                                                    <div style={{ fontSize: 13, fontWeight: 500 }}>{moment(conteo.fechaInicio).format("DD/MM/YYYY")}</div>
                                                </Col>
                                            )}
                                            {conteo.fechaVencimiento && (
                                                <Col>
                                                    <div style={{ fontSize: 11, color: "#8c8c8c" }}>Vencimiento</div>
                                                    <div style={{ fontSize: 13, fontWeight: 500 }}>{moment(conteo.fechaVencimiento).format("DD/MM/YYYY")}</div>
                                                </Col>
                                            )}
                                        </Row>
                                    </Card>
                                )}

                                {/* Progreso */}
                                <Card
                                    style={{ marginBottom: 16, borderRadius: 8, border: "1px solid #f0f0f0" }}
                                    bodyStyle={{ padding: "16px 20px" }}
                                >
                                    <Row gutter={24} align="middle">
                                        <Col xs={24} md={6}>
                                            <Statistic title="Total órdenes" value={totalOrdenes} />
                                        </Col>
                                        <Col xs={24} md={6}>
                                            <Statistic title="Contadas" value={contadas} suffix={`/ ${totalOrdenes}`} />
                                        </Col>
                                        <Col xs={24} md={6}>
                                            <Statistic
                                                title="Aprobadas"
                                                value={aprobadas}
                                                suffix={`/ ${totalOrdenes}`}
                                                valueStyle={{ color: todasAprobadas ? "#52c41a" : undefined }}
                                            />
                                        </Col>
                                        <Col xs={24} md={6}>
                                            <div style={{ fontSize: 13, color: "#888", marginBottom: 4 }}>Avance</div>
                                            <Progress percent={progreso} status={todasAprobadas ? "success" : "active"} />
                                        </Col>
                                    </Row>
                                </Card>

                                {/* Tabla de órdenes */}
                                <TableItem
                                    loading={loading}
                                    dataSource={ordenes}
                                    columns={columnasOrdenes}
                                    rowKey="_id"
                                    size="small"
                                    pagination={false}
                                    scroll={{ x: "max-content" }}
                                    style={{ marginBottom: 16 }}
                                    rowClassName={(r) => r.estado === 3 ? "fila-aprobada" : ""}
                                />

                                {/* Diferencias */}
                                {todasAprobadas && (
                                    <>
                                        <Divider>Análisis de Diferencias</Divider>
                                        {!mostrandoDif ? (
                                            <div style={{ textAlign: "center", marginBottom: 16 }}>
                                                <ButtonItem
                                                    type="primary"
                                                    onClick={this.consultarDiferencias.bind(this)}
                                                    loading={loadingDif}
                                                >
                                                    Ver diferencias
                                                </ButtonItem>
                                            </div>
                                        ) : (
                                            <Spin spinning={loadingDif}>
                                                {diferencias.length > 0 ? (
                                                    <>
                                                        <TableItem
                                                            dataSource={diferencias}
                                                            columns={columnasDif}
                                                            rowKey="insumoId"
                                                            size="small"
                                                            pagination={false}
                                                            scroll={{ x: "max-content" }}
                                                            style={{ marginBottom: 16 }}
                                                            rowClassName={(r) => r.diferenciaFinal !== 0 ? "fila-diferencia" : ""}
                                                        />
                                                        {/* Ningun proceso pasa el conteo a 2 (En revision): se crea en 1 y aplicar ajustes lo deja en 3 */}
                                                        {diferencias.some((d) => !d.ajusteAplicado) && (conteo.estado === 1 || conteo.estado === 2) && (
                                                            <>
                                                                <Alert
                                                                    type="warning"
                                                                    showIcon
                                                                    style={{ marginBottom: 12 }}
                                                                    message="Aviso sobre insumos con lotes y caducidades"
                                                                    description="Los insumos que manejen lotes y caducidades y presenten una diferencia positiva se registrarán en el lote AJUSTE- sin caducidad. En el caso de diferencias negativas, el ajuste se aplicará dando de baja el lote con la fecha de caducidad más próxima."
                                                                />
                                                                <Alert
                                                                    type="info"
                                                                    showIcon
                                                                    style={{ marginBottom: 12 }}
                                                                    message="Las diferencias crean Ordenes de Agregar Inventario o Productos al Costo"
                                                                    description="Las diferencias positivas crearán órdenes de agregar inventario, mientras que las negativas crearán órdenes de productos al costo. Estas se tendran que confirmar manualmente para que los ajustes se reflejen en el inventario. Revise las órdenes creadas para verificar los insumos afectados y sus lotes asignados."
                                                                />
                                                                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                                                    <Popconfirm
                                                                        title="¿Aplicar los ajustes de inventario?"
                                                                        description="Esta acción no se puede deshacer. Los insumos con lotes y caducidades se ajustarán según las reglas indicadas."
                                                                        onConfirm={this.aplicarAjustes.bind(this)}
                                                                        okText="Aplicar"
                                                                        cancelText="Cancelar"
                                                                        icon={<ExclamationCircleOutlined style={{ color: "#f5222d" }} />}
                                                                    >
                                                                        <ButtonItem type="primary" loading={loadingAjuste} danger>
                                                                            Aplicar ajustes al inventario
                                                                        </ButtonItem>
                                                                    </Popconfirm>
                                                                </div>
                                                            </>
                                                        )}
                                                        {/* ajusteAplicado no se persiste (el modelo no tiene insumos.ajuste); el estado 3 del conteo es la fuente real */}
                                                        {(conteo.estado === 3 || diferencias.every((d) => d.ajusteAplicado)) && (
                                                            <Alert
                                                                type="success"
                                                                message="Todos los ajustes han sido aplicados al inventario."
                                                                showIcon
                                                            />
                                                        )}
                                                    </>
                                                ) : (
                                                    <Alert type="success" message="Sin diferencias — el inventario coincide con los conteos." showIcon />
                                                )}
                                            </Spin>
                                        )}
                                    </>
                                )}
                            </Spin>
                        </TabPane>

                        {todasAprobadas && (
                            <TabPane tab="Estadísticas" key="estadisticas">
                                <Spin spinning={loadingDif}>
                                    {resumenDif ? (
                                        <>
                                            {/* Dona */}
                                            <Row gutter={24} style={{ marginBottom: 24 }}>
                                                <Col xs={24} md={10}>
                                                    <Card
                                                        title="Precisión del conteo"
                                                        style={{ borderRadius: 8 }}
                                                        bodyStyle={{ padding: "16px 20px" }}
                                                    >
                                                        <div style={{ height: 280 }}>
                                                            <ResponsivePie
                                                                data={[
                                                                    {
                                                                        id: "Sin diferencia",
                                                                        label: `Sin diferencia (${resumenDif.insumosSinDiferencia})`,
                                                                        value: resumenDif.insumosSinDiferencia,
                                                                        color: "#52c41a",
                                                                    },
                                                                    {
                                                                        id: "Con diferencia",
                                                                        label: `Con diferencia (${resumenDif.insumosConDiferencia})`,
                                                                        value: resumenDif.insumosConDiferencia,
                                                                        color: "#f5222d",
                                                                    },
                                                                ].filter((d) => d.value > 0)}
                                                                margin={{ top: 20, right: 20, bottom: 60, left: 20 }}
                                                                innerRadius={0.6}
                                                                padAngle={2}
                                                                cornerRadius={3}
                                                                colors={({ data }) => data.color}
                                                                arcLinkLabelsSkipAngle={10}
                                                                arcLinkLabelsTextColor="#444"
                                                                arcLabelsSkipAngle={15}
                                                                arcLabelsTextColor="#fff"
                                                                legends={[{
                                                                    anchor: "bottom",
                                                                    direction: "row",
                                                                    itemWidth: 140,
                                                                    itemHeight: 18,
                                                                    translateY: 56,
                                                                    symbolShape: "circle",
                                                                    itemTextColor: "#444",
                                                                }]}
                                                            />
                                                        </div>
                                                        <Row gutter={16} style={{ marginTop: 8, textAlign: "center" }}>
                                                            <Col span={8}>
                                                                <Statistic title="Total" value={resumenDif.totalInsumos} valueStyle={{ fontSize: 20 }} />
                                                            </Col>
                                                            <Col span={8}>
                                                                <Statistic title="Correctos" value={resumenDif.insumosSinDiferencia} valueStyle={{ fontSize: 20, color: "#52c41a" }} />
                                                            </Col>
                                                            <Col span={8}>
                                                                <Statistic title="Con dif." value={resumenDif.insumosConDiferencia} valueStyle={{ fontSize: 20, color: "#f5222d" }} />
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                </Col>

                                                {/* Barra horizontal de diferencias */}
                                                <Col xs={24} md={14}>
                                                    <Card
                                                        title="Insumos con mayor diferencia"
                                                        style={{ borderRadius: 8 }}
                                                        bodyStyle={{ padding: "16px 20px" }}
                                                    >
                                                        {(() => {
                                                            const barData = diferencias
                                                                .filter((d) => d.diferenciaFinal !== 0)
                                                                .sort((a, b) => Math.abs(b.diferenciaFinal) - Math.abs(a.diferenciaFinal))
                                                                .slice(0, 15)
                                                                .map((d) => ({
                                                                    insumo: d.nombre?.length > 28 ? d.nombre.substring(0, 28) + "…" : (d.nombre || "—"),
                                                                    diferencia: d.diferenciaFinal,
                                                                    color: d.diferenciaFinal > 0 ? "#1677ff" : "#f5222d",
                                                                }))
                                                                .reverse();
                                                            const chartHeight = Math.max(260, barData.length * 36);
                                                            return barData.length > 0 ? (
                                                                <div style={{ height: chartHeight }}>
                                                                    <ResponsiveBar
                                                                        data={barData}
                                                                        keys={["diferencia"]}
                                                                        indexBy="insumo"
                                                                        layout="horizontal"
                                                                        margin={{ top: 10, right: 70, bottom: 30, left: 190 }}
                                                                        colors={({ data }) => data.color}
                                                                        valueFormat={(v) => (v > 0 ? `+${v}` : `${v}`)}
                                                                        axisLeft={{ tickSize: 0, tickPadding: 8 }}
                                                                        axisBottom={{ tickValues: 5 }}
                                                                        enableGridY={false}
                                                                        labelSkipWidth={30}
                                                                        labelTextColor="#fff"
                                                                        tooltip={({ data: d, value }) => (
                                                                            <div style={{ background: "#fff", border: "1px solid #ddd", borderRadius: 4, padding: "6px 10px", fontSize: 12 }}>
                                                                                <strong>{d.insumo}</strong>: {value > 0 ? `+${value}` : value}
                                                                            </div>
                                                                        )}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <Alert type="success" message="Ningún insumo tiene diferencias." showIcon />
                                                            );
                                                        })()}
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </>
                                    ) : (
                                        <Alert
                                            type="info"
                                            message="Las estadísticas se cargan automáticamente al abrir esta pestaña."
                                            showIcon
                                        />
                                    )}
                                </Spin>
                            </TabPane>
                        )}

                        <TabPane tab="Por orden" key="porOrden">
                            {(() => {
                                const { resumenPorOrden, loadingResumen } = this.state;
                                const barPorOrden = [...ordenes]
                                    .map((o) => {
                                        const pct = o.totalInsumos > 0
                                            ? Math.round(((o.insumosContados ?? 0) / o.totalInsumos) * 100)
                                            : 0;
                                        return {
                                            orden: (o.responsableNombre || o.serieNumero || "—").substring(0, 28),
                                            "% Contados": pct,
                                            color: o.estado === 3 ? "#52c41a" : o.estado === 2 ? "#1677ff" : "#8c8c8c",
                                        };
                                    })
                                    .reverse();

                                const columnasPorOrden = [
                                    { title: "N°", dataIndex: "serieNumero", key: "serieNumero", width: "7%" },
                                    { title: "Responsable", dataIndex: "responsableNombre", key: "responsableNombre", width: "18%" },
                                    { title: "Supervisor", dataIndex: "supervisorNombre", key: "supervisorNombre", width: "15%" },
                                    {
                                        title: "Insumos",
                                        key: "insumos",
                                        width: "10%",
                                        align: "right",
                                        render: (_, r) => `${r.insumosContados ?? 0} / ${r.totalInsumos ?? 0}`,
                                    },
                                    {
                                        title: "% Avance",
                                        key: "pct",
                                        width: "10%",
                                        align: "right",
                                        render: (_, r) => {
                                            const pct = r.totalInsumos > 0
                                                ? Math.round(((r.insumosContados ?? 0) / r.totalInsumos) * 100)
                                                : 0;
                                            const color = pct === 100 ? "#52c41a" : pct > 0 ? "#1677ff" : "#8c8c8c";
                                            return <span style={{ color, fontWeight: 600 }}>{pct}%</span>;
                                        },
                                    },
                                    {
                                        title: "Estado",
                                        dataIndex: "estado",
                                        key: "estado",
                                        width: "10%",
                                        render: (v) => this.renderEstadoOrden(v),
                                    },
                                    {
                                        title: "Inicio",
                                        dataIndex: "fechaInicio",
                                        key: "fechaInicio",
                                        width: "12%",
                                        render: (v) => v ? moment(v).format("DD/MM/YY HH:mm") : "—",
                                    },
                                    {
                                        title: "Duración",
                                        key: "duracion",
                                        width: "10%",
                                        align: "right",
                                        render: (_, r) => {
                                            if (!r.fechaInicio || !r.fechaTermino) return "—";
                                            const min = moment(r.fechaTermino).diff(moment(r.fechaInicio), "minutes");
                                            return min >= 60
                                                ? `${Math.floor(min / 60)}h ${min % 60}m`
                                                : `${min} min`;
                                        },
                                    },
                                ];

                                const chartHeight = Math.max(260, barPorOrden.length * 40);
                                return (
                                    <>
                                        {barPorOrden.length > 0 && (
                                            <Card
                                                title="Avance por orden"
                                                style={{ marginBottom: 16, borderRadius: 8 }}
                                                bodyStyle={{ padding: "16px 20px" }}
                                            >
                                                <div style={{ height: chartHeight }}>
                                                    <ResponsiveBar
                                                        data={barPorOrden}
                                                        keys={["% Contados"]}
                                                        indexBy="orden"
                                                        layout="horizontal"
                                                        margin={{ top: 10, right: 60, bottom: 30, left: 200 }}
                                                        colors={({ data }) => data.color}
                                                        maxValue={100}
                                                        valueFormat={(v) => `${v}%`}
                                                        axisLeft={{ tickSize: 0, tickPadding: 8 }}
                                                        axisBottom={{ tickValues: [0, 25, 50, 75, 100], format: (v) => `${v}%` }}
                                                        enableGridY={false}
                                                        labelSkipWidth={30}
                                                        labelTextColor="#fff"
                                                        tooltip={({ indexValue, value }) => (
                                                            <div style={{ background: "#fff", border: "1px solid #ddd", borderRadius: 4, padding: "6px 10px", fontSize: 12 }}>
                                                                <strong>{indexValue}</strong>: {value}%
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                            </Card>
                                        )}
                                        <TableItem
                                            dataSource={ordenes}
                                            columns={columnasPorOrden}
                                            rowKey="_id"
                                            size="small"
                                            pagination={false}
                                            scroll={{ x: "max-content" }}
                                            rowClassName={(r) => r.estado === 3 ? "fila-aprobada" : ""}
                                        />

                                        <Spin spinning={loadingResumen}>
                                            {resumenPorOrden.length > 0 && (() => {
                                                const barDif = [...resumenPorOrden]
                                                    .sort((a, b) => (b.insumosConDiferencia ?? 0) - (a.insumosConDiferencia ?? 0))
                                                    .slice(0, 15)
                                                    .map((r) => ({
                                                        responsable: (r.responsableNombre || "—").substring(0, 28),
                                                        "Con diferencia": r.insumosConDiferencia ?? 0,
                                                        color: "#f5222d",
                                                    }))
                                                    .reverse();
                                                const h = Math.max(260, barDif.length * 40);
                                                return (
                                                    <Card
                                                        title="Responsables con más diferencias"
                                                        style={{ marginTop: 16, borderRadius: 8 }}
                                                        bodyStyle={{ padding: "16px 20px" }}
                                                    >
                                                        <div style={{ height: h }}>
                                                            <ResponsiveBar
                                                                data={barDif}
                                                                keys={["Con diferencia"]}
                                                                indexBy="responsable"
                                                                layout="horizontal"
                                                                margin={{ top: 10, right: 70, bottom: 30, left: 200 }}
                                                                colors={({ data }) => data.color}
                                                                axisLeft={{ tickSize: 0, tickPadding: 8 }}
                                                                axisBottom={{ tickValues: 5 }}
                                                                enableGridY={false}
                                                                labelSkipWidth={24}
                                                                labelTextColor="#fff"
                                                                tooltip={({ indexValue, value }) => (
                                                                    <div style={{ background: "#fff", border: "1px solid #ddd", borderRadius: 4, padding: "6px 10px", fontSize: 12 }}>
                                                                        <strong>{indexValue}</strong>: {value} insumo{value !== 1 ? "s" : ""} con diferencia
                                                                    </div>
                                                                )}
                                                            />
                                                        </div>
                                                    </Card>
                                                );
                                            })()}
                                        </Spin>
                                    </>
                                );
                            })()}
                        </TabPane>

                        <TabPane tab="Reconteos" key="reconteos">
                            {(() => {
                                const { resumenReconteos, loadingReconteos } = this.state;
                                // Mismo criterio que las demas tablas: la columna solo aparece si
                                // algun insumo del top trae codigo de barras capturado.
                                const mostrarCodigoBarrasReconteos = (resumenReconteos?.masReconteados || [])
                                    .some((i) => !!i.codigoBarras);
                                return (
                                    <Spin spinning={loadingReconteos}>
                                        {resumenReconteos ? (
                                            <>
                                                {/* Tarjetas resumen */}
                                                <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                                                    <Col xs={24} sm={8}>
                                                        <Card bodyStyle={{ padding: "16px 20px", textAlign: "center" }} style={{ borderRadius: 8, border: "1px solid #f0f0f0" }}>
                                                            <div style={{ fontSize: 28, fontWeight: 700, color: "#1677ff" }}>
                                                                {resumenReconteos.totalReconteos ?? 0}
                                                            </div>
                                                            <div style={{ fontSize: 13, color: "#8c8c8c", marginTop: 4 }}>Reconteos totales</div>
                                                        </Card>
                                                    </Col>
                                                    <Col xs={24} sm={8}>
                                                        <Card bodyStyle={{ padding: "16px 20px", textAlign: "center" }} style={{ borderRadius: 8, border: "1px solid #f0f0f0" }}>
                                                            <div style={{ fontSize: 28, fontWeight: 700, color: "#f5222d" }}>
                                                                {resumenReconteos.insumosConReconteo ?? 0}
                                                            </div>
                                                            <div style={{ fontSize: 13, color: "#8c8c8c", marginTop: 4 }}>Insumos con reconteo</div>
                                                        </Card>
                                                    </Col>
                                                    <Col xs={24} sm={8}>
                                                        <Card bodyStyle={{ padding: "16px 20px", textAlign: "center" }} style={{ borderRadius: 8, border: "1px solid #f0f0f0" }}>
                                                            <div style={{ fontSize: 28, fontWeight: 700, color: "#52c41a" }}>
                                                                {resumenReconteos.totalInsumos
                                                                    ? `${(((resumenReconteos.insumosConReconteo ?? 0) / resumenReconteos.totalInsumos) * 100).toFixed(1)}%`
                                                                    : "—"}
                                                            </div>
                                                            <div style={{ fontSize: 13, color: "#8c8c8c", marginTop: 4 }}>Tasa de reconteo</div>
                                                        </Card>
                                                    </Col>
                                                </Row>

                                                <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                                                    {/* Gráfica distribución */}
                                                    <Col xs={24} md={12}>
                                                        <Card
                                                            title="Distribución de reconteos"
                                                            style={{ borderRadius: 8 }}
                                                            bodyStyle={{ padding: "16px 20px" }}
                                                        >
                                                            {(() => {
                                                                const dist = (resumenReconteos.distribucion || []).map((d) => ({
                                                                    reconteos: d.numReconteos === 0
                                                                        ? "Sin reconteo"
                                                                        : d.numReconteos === 1
                                                                            ? "1 reconteo"
                                                                            : `${d.numReconteos} reconteos`,
                                                                    "Insumos": d.cantidadInsumos,
                                                                    color: d.numReconteos === 0 ? "#52c41a" : d.numReconteos === 1 ? "#faad14" : "#f5222d",
                                                                }));
                                                                return dist.length > 0 ? (
                                                                    <div style={{ height: 240 }}>
                                                                        <ResponsiveBar
                                                                            data={dist}
                                                                            keys={["Insumos"]}
                                                                            indexBy="reconteos"
                                                                            margin={{ top: 10, right: 20, bottom: 50, left: 50 }}
                                                                            colors={({ data }) => data.color}
                                                                            axisBottom={{ tickSize: 0, tickPadding: 8, tickRotation: -20 }}
                                                                            axisLeft={{ tickSize: 0, tickPadding: 8 }}
                                                                            enableGridX={false}
                                                                            labelSkipHeight={14}
                                                                            labelTextColor="#fff"
                                                                            tooltip={({ indexValue, value }) => (
                                                                                <div style={{ background: "#fff", border: "1px solid #ddd", borderRadius: 4, padding: "6px 10px", fontSize: 12 }}>
                                                                                    <strong>{indexValue}</strong>: {value} insumo{value !== 1 ? "s" : ""}
                                                                                </div>
                                                                            )}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <Alert type="info" message="Sin datos de distribución." showIcon />
                                                                );
                                                            })()}
                                                        </Card>
                                                    </Col>

                                                    {/* Gráfica por responsable */}
                                                    <Col xs={24} md={12}>
                                                        <Card
                                                            title="Reconteos por responsable"
                                                            style={{ borderRadius: 8 }}
                                                            bodyStyle={{ padding: "16px 20px" }}
                                                        >
                                                            {(() => {
                                                                const porResp = (resumenReconteos.porResponsable || [])
                                                                    .sort((a, b) => (b.totalReconteos ?? 0) - (a.totalReconteos ?? 0))
                                                                    .map((r) => ({
                                                                        responsable: (r.responsableNombre || "—").substring(0, 22),
                                                                        "Reconteos": r.totalReconteos ?? 0,
                                                                        color: (r.totalReconteos ?? 0) === 0 ? "#52c41a" : (r.totalReconteos ?? 0) <= 3 ? "#faad14" : "#f5222d",
                                                                    }))
                                                                    .reverse();
                                                                const h = Math.max(200, porResp.length * 36);
                                                                return porResp.length > 0 ? (
                                                                    <div style={{ height: h }}>
                                                                        <ResponsiveBar
                                                                            data={porResp}
                                                                            keys={["Reconteos"]}
                                                                            indexBy="responsable"
                                                                            layout="horizontal"
                                                                            margin={{ top: 10, right: 60, bottom: 30, left: 160 }}
                                                                            colors={({ data }) => data.color}
                                                                            axisLeft={{ tickSize: 0, tickPadding: 8 }}
                                                                            axisBottom={{ tickValues: 5 }}
                                                                            enableGridY={false}
                                                                            labelSkipWidth={20}
                                                                            labelTextColor="#fff"
                                                                            tooltip={({ indexValue, value }) => (
                                                                                <div style={{ background: "#fff", border: "1px solid #ddd", borderRadius: 4, padding: "6px 10px", fontSize: 12 }}>
                                                                                    <strong>{indexValue}</strong>: {value} reconteo{value !== 1 ? "s" : ""}
                                                                                </div>
                                                                            )}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <Alert type="success" message="Ningún responsable tiene reconteos." showIcon />
                                                                );
                                                            })()}
                                                        </Card>
                                                    </Col>
                                                </Row>

                                                {/* Tabla insumos más reconteados */}
                                                {(resumenReconteos.masReconteados || []).length > 0 && (
                                                    <Card
                                                        title="Insumos con más reconteos"
                                                        style={{ borderRadius: 8 }}
                                                        bodyStyle={{ padding: "0" }}
                                                    >
                                                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ ...TH_LEFT, padding: "10px 16px" }}>Insumo</th>
                                                                    {mostrarCodigoBarrasReconteos && (
                                                                        <th style={{ ...TH_LEFT, padding: "10px 16px" }}>Cód. barras</th>
                                                                    )}
                                                                    <th style={{ ...TH_NUM(), padding: "10px 16px" }}>Reconteos</th>
                                                                    <th style={{ ...TH_NUM(), padding: "10px 16px" }}>Órdenes afectadas</th>
                                                                    <th style={{ ...TH_CENTER(), padding: "10px 16px" }}>Severidad</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {resumenReconteos.masReconteados.map((item, idx) => {
                                                                    const sev = item.totalReconteos >= 5 ? { label: "Alta", color: "#f5222d" }
                                                                        : item.totalReconteos >= 2 ? { label: "Media", color: "#faad14" }
                                                                            : { label: "Baja", color: "#52c41a" };
                                                                    return (
                                                                        <tr key={idx} style={{ background: idx % 2 === 0 ? "#fafafa" : "#fff" }}>
                                                                            <td style={{ ...TD_LEFT, padding: "9px 16px" }}>{item.nombre || "—"}</td>
                                                                            {mostrarCodigoBarrasReconteos && (
                                                                                <td style={{ ...TD_LEFT, padding: "9px 16px", color: "#595959", fontFamily: "monospace" }}>
                                                                                    {item.codigoBarras || "—"}
                                                                                </td>
                                                                            )}
                                                                            <td style={{ ...TD_RIGHT(), padding: "9px 16px", fontWeight: 600, color: "#1677ff" }}>{item.totalReconteos}</td>
                                                                            <td style={{ ...TD_RIGHT(), padding: "9px 16px" }}>{item.ordenesAfectadas ?? "—"}</td>
                                                                            <td style={{ ...TD_CENTER(), padding: "9px 16px" }}>
                                                                                <Tag color={sev.color === "#f5222d" ? "red" : sev.color === "#faad14" ? "orange" : "green"}>
                                                                                    {sev.label}
                                                                                </Tag>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </Card>
                                                )}
                                            </>
                                        ) : (
                                            !loadingReconteos && (
                                                <Alert
                                                    type="info"
                                                    message="Los datos de reconteos se cargan al abrir esta pestaña."
                                                    showIcon
                                                />
                                            )
                                        )}
                                    </Spin>
                                );
                            })()}
                        </TabPane>

                    </Tabs>
                </div>

                {/* Modal de revisión */}
                <Modal
                    title={ordenSeleccionada
                        ? `Orden — ${ordenSeleccionada.responsableNombre || ""}`
                        : "Revisar orden"}
                    visible={modalVisible}
                    onCancel={this.cerrarModal.bind(this)}
                    width={960}
                    footer={null}
                    destroyOnClose
                >
                    <Spin spinning={loadingModal}>
                        {insumosModal.length > 0 && (
                            <>
                                {/* Info de la orden en el modal */}
                                {ordenSeleccionada && (
                                    <Card
                                        style={{ marginBottom: 14, borderRadius: 8, border: "1px solid #d9f2f5", background: "#f0f9fa" }}
                                        bodyStyle={{ padding: "10px 16px" }}
                                    >
                                        <Row gutter={[24, 4]}>
                                            <Col>
                                                <div style={{ fontSize: 11, color: "#8c8c8c" }}>Responsable</div>
                                                <div style={{ fontSize: 13 }}>{ordenSeleccionada.responsableNombre || "—"}</div>
                                            </Col>
                                            <Col>
                                                <div style={{ fontSize: 11, color: "#8c8c8c" }}>Supervisor</div>
                                                <div style={{ fontSize: 13 }}>{ordenSeleccionada.supervisorNombre || "—"}</div>
                                            </Col>
                                            <Col>
                                                <div style={{ fontSize: 11, color: "#8c8c8c" }}>Proyecto</div>
                                                <div style={{ fontSize: 13 }}>{ordenSeleccionada.proyectoNombre || "—"}</div>
                                            </Col>
                                            <Col>
                                                <div style={{ fontSize: 11, color: "#8c8c8c" }}>Estado</div>
                                                <div style={{ marginTop: 2 }}>{this.renderEstadoOrden(ordenSeleccionada.estado)}</div>
                                            </Col>
                                        </Row>
                                    </Card>
                                )}

                                <div style={{ overflowX: "auto", marginBottom: 16 }}>
                                    <table className="table" style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                                        <thead>
                                            <tr>
                                                <th className="th-border" style={TH_LEFT}>Insumo</th>
                                                {mostrarCodigoBarrasModal && (
                                                    <th className="th-border" style={TH_LEFT}>Cód. barras</th>
                                                )}
                                                {Array.from({ length: maxConteos }, (_, i) => (
                                                    <th key={i} className="th-border" style={TH_NUM({ width: "11%" })}>
                                                        {i === 0 ? "Conteo 1" : `Reconteo ${i}`}
                                                    </th>
                                                ))}
                                                <th className="th-border" style={TH_NUM({ width: "11%" })}>Dif. final</th>
                                                <th className="th-border" style={TH_NUM({ width: "11%" })}>Snapshot</th>
                                                <th className="th-border" style={TH_NUM({ width: "11%" })}>% Dif.</th>
                                                <th className="th-border" style={TH_CENTER({ width: "10%" })}>Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {insumosModal.map((item, idx) => {
                                                const ultimo = item.conteos?.[item.conteos.length - 1];
                                                const diff = item.resolucion?.diferenciaFinal ?? ultimo?.diferenciaVsSnapshot;
                                                const snapshot = item.resolucion?.snapshotFinal ?? item.snapshot?.existenciaSistema;
                                                const pctDiff = diff != null && snapshot != null && snapshot !== 0
                                                    ? ((diff / snapshot) * 100).toFixed(2)
                                                    : null;

                                                const rowBg = item.conteos?.length > 0
                                                    ? diff === 0 ? "#f6ffed" : diff != null ? "#fff1f0" : "#fffbe6"
                                                    : undefined;

                                                const diffColor = diff === 0 ? "#52c41a" : diff != null ? "#f5222d" : undefined;
                                                const pctColor = pctDiff !== null && parseFloat(pctDiff) === 0 ? "#52c41a" : pctDiff !== null ? "#f5222d" : undefined;

                                                const tagInsumo = () => {
                                                    if (item.resolucion?.cantidadFinal != null) return <Tag color="green">Resuelto</Tag>;
                                                    if (item.requiereReconteo) return <Tag color="orange">Reconteo</Tag>;
                                                    if (item.conteos?.length > 0) return <Tag color="blue">Contado</Tag>;
                                                    return <Tag color="default">Pendiente</Tag>;
                                                };

                                                return (
                                                    <tr key={idx} style={rowBg ? { background: rowBg } : undefined}>
                                                        <td className="td-border" style={TD_LEFT}>{item.nombre || "—"}</td>
                                                        {mostrarCodigoBarrasModal && (
                                                            <td className="td-border" style={TD_LEFT}>
                                                                <span style={{ color: "#595959", fontFamily: "monospace" }}>
                                                                    {item.codigoBarras || "—"}
                                                                </span>
                                                            </td>
                                                        )}
                                                        {Array.from({ length: maxConteos }, (_, i) => (
                                                            <td key={i} className="td-border" style={TD_RIGHT({ color: "#595959" })}>
                                                                {item.conteos?.[i]?.cantidadContada ?? "—"}
                                                            </td>
                                                        ))}
                                                        <td className="td-border" style={TD_RIGHT({ fontWeight: 600, color: diffColor })}>
                                                            {diff != null ? (diff > 0 ? `+${diff}` : diff) : "—"}
                                                        </td>
                                                        <td className="td-border" style={TD_RIGHT()}>{snapshot ?? "—"}</td>
                                                        <td className="td-border" style={TD_RIGHT({ fontWeight: 600, color: pctColor })}>
                                                            {pctDiff !== null ? `${parseFloat(pctDiff) > 0 ? "+" : ""}${pctDiff}%` : "—"}
                                                        </td>
                                                        <td className="td-border" style={TD_CENTER()}>{tagInsumo()}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                <Row justify="end" gutter={8}>
                                    <Col>
                                        <ButtonItem onClick={this.cerrarModal.bind(this)}>
                                            Cancelar
                                        </ButtonItem>
                                    </Col>
                                    {esSupervisorDeOrden && (
                                        <Col>
                                            <Popconfirm
                                                title="¿Rechazar esta orden y solicitar reconteo? El responsable deberá volver a contar."
                                                onConfirm={this.rechazarOrden.bind(this)}
                                                okText="Rechazar"
                                                okButtonProps={{ danger: true }}
                                                cancelText="Cancelar"
                                                icon={<ExclamationCircleOutlined style={{ color: "#f5222d" }} />}
                                            >
                                                <ButtonItem
                                                    danger
                                                    icon={<CloseOutlined />}
                                                >
                                                    Rechazar y pedir reconteo
                                                </ButtonItem>
                                            </Popconfirm>
                                        </Col>
                                    )}
                                    {esSupervisorDeOrden && (
                                        <Col>
                                            <Popconfirm
                                                title="¿Aprobar esta orden? Se confirma que el conteo es correcto."
                                                onConfirm={this.aprobarOrden.bind(this)}
                                                okText="Aprobar"
                                                cancelText="Cancelar"
                                            >
                                                <ButtonItem type="primary" icon={<CheckOutlined />}>
                                                    Aprobar orden
                                                </ButtonItem>
                                            </Popconfirm>
                                        </Col>
                                    )}
                                </Row>
                            </>
                        )}
                        {!loadingModal && insumosModal.length === 0 && (
                            <Alert type="info" message="No hay insumos para mostrar." showIcon />
                        )}
                    </Spin>
                </Modal>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    usuarioId: state.user.usuarioId,
});

export default connect(mapStateToProps)(DetalleConteo);
